import React, { useState, useEffect } from 'react'
import { ChevronLeft } from 'react-feather'
import apiClient from '../../../utils/backend'
import 'react-toastify/dist/ReactToastify.css'
import { StepBar } from './components/StepBar'
import { StageStepOne } from './Stages/StageStepOne'
import { TreatmentAdminStepThree } from '../components/TreatmentAdminStepThree'
import { TreatmentAdminStepTwo } from '../components/TreatmentAdminStepTwo'
import { StageStepFour } from './Stages/StageStepFour'
import { StageStepSix } from './Stages/StageStepSix'
import frontalsonriendo from '../../../assets/images/frontalsonriendo.png'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../../../components/loader'
import handleToast from '../../../components/toaster'
import { TreatmentStepFive } from '../components/TreatmentStepFive'

export const NewStage = () => {
  const { pageWidth } = useSelector((state) => state.pageWidthReducer)
  const [planFiles, setPlanFiles] = useState([])
  const { dentistId, name, surname } = useSelector((state) => state.userReducer)
  const [stageOneFinish, setStageOneFinish] = useState(false)
  const [stageTwoFinish, setStageTwoFinish] = useState(false)
  const [stageThreeFinish, setStageThreeFinish] = useState(false)
  const [stageFourFinish, setStageFourFinish] = useState(false)
  const [stageFiveFinish, setStageFiveFinish] = useState(false)
  const [photosFiles, setPhotosFiles] = useState([])
  const [studiesFiles, setStudiesFiles] = useState([])
  const [state, setState] = useState({
    dentist_id: dentistId,
    numPages: null,
    pageNumber: 1,
    treatment_id: null,
    plantratamiento: null,
    step: 1,
    patient: null,

    // VISTA 1
    gender_select: null,
    loading: false,
    patients: null,
    nombre: null,
    apellido: null,
    genero: null,
    maxilla: null,
    maxilar: 0,
    maxilar_string: '',
    external_id: null,
    odontologo: '',
    treatment_type: 1,
    intraoral: 2,
    is3Shape: false,
    isWeTransfer: false,
    etapa: 1,
    is_new_patient: false,
    od_patients: [],
    selected_patient: null,
    selected_od: null,
    treatmentList: null,
    dentistOffices: null,
    newIntraoralScanDate: null,
    sendImpressions: {},

    fotos: {},
    fotos_files: [],
    estudios: {},
    estudios_files: [],
    plan: {},

    registration_datetime: null,
    scan_file: null,

    // STEP DATA
    flag_photos: 0,
    flag_studies: 0,
    flag_plan: 0,

    // ERROR HANDLER
    error: {
      error: false,
      message: '',
    },

    // CROPPER
    cropper: false,
    cropper_img: null,
    cropper_file: null,

    errors: [],
  })

  const dispatch = useDispatch()

  const stageTitleArray = [
    null,
    'Cargar Datos',
    'Adjuntar Fotos',
    'Adjuntar Estudios',
    'Adjuntar Plan de Tratamiento',
    'Envío de Registro',
  ]

  const text = (
    <p className="text-center">
      Recuerde que puede cargar fotos y estudios en otro momento. Podrá acceder
      a sus pacientes con acciones requeridas para adjuntar las fotos o estudios
      faltantes, <br />
      <b>
        KeepSmiling no dará comienzo al tratamiento hasta no recibir toda la
        documentación.
      </b>
    </p>
  )

  const stageFooterArray = [
    null,
    <p className="text-center">
      Todas las solicitudes enviadas, serán revisadas por el equipo de
      KeepSmiling y usted recibirá un seguimiento por parte del equipo. Una
      solicitud no es un paciente ingresado aún. <br />
      Para cualquier consulta, puede comunicarse por ... al XXXXXXXXXXXXXXXX
    </p>,
    text,
    text,
    text,
    text,
  ]

  const handleChangeStep = () => {
    if (!stageOneFinish)
      return handleToast('error', 'Todos los campos son requeridos')
    if (state.step === 5 && !stageFiveFinish)
      return handleToast('error', 'Todos los campos son requeridos')
    setState({ ...state, step: state.step + 1 })
  }

  useEffect(() => {
    apiClient
      .get(`/api/dentists/${dentistId}/patients?include=lastTreatment`)
      .then((res) => {
        if (res.status === 200) {
          console.log(res)
          setState({
            ...state,
            odontologo: {
              id: dentistId,
              value: dentistId,
              name: name,
              surname: surname,
              label: `${name}, ${surname}`,
              patients: res.data.table.body,
            },
          })
        }
      })
      .catch((err) => console.log(err))
  }, [])

  useEffect(() => {
    // Validate Step 1
    if (
      state.odontologo &&
      state.nombre &&
      state.apellido &&
      state.genero &&
      state.maxilla
    ) {
      setStageOneFinish(true)
    } else setStageOneFinish(false)

    // Validate Step 2
    let i = 0
    const values = Object.values(state.fotos)
    values.forEach((value) => {
      if (value !== null) ++i
    })
    if (i > 9) setStageTwoFinish(true)
    else setStageTwoFinish(false)

    // Validate Step 3
    if (state.telerradiografia && state.rxpanoramica && state.ricketts) {
      setStageThreeFinish(true)
    } else setStageThreeFinish(false)

    // Validate Step 4
    if (planFiles.length || state?.online_form_state) {
      setStageFourFinish(true)
    } else setStageFourFinish(false)

    //Validate Step 5
    if (state) {
      if (state.intraoral === 1 && !state.isWeTransfer && !state.is3Shape) {
        return setStageFiveFinish(false)
      }
      if (state.newIntraoralScanDate) return setStageFiveFinish(true)
      if (
        state.sendImpressions.takeover_date &&
        state.sendImpressions.dateToGet &&
        state.sendImpressions.withdrawalAddress
      )
        return setStageFiveFinish(true)
      setStageFiveFinish(false)
    }
  }, [state])

  const checkFrotalSonriendo = () => {
    if (state?.frontal_sonriendo) {
      return state.frontal_sonriendo
    }
    if (state?.selected_patient?.patientImage) {
      return state?.selected_patient?.patientImage
    }
    return frontalsonriendo
  }

  useEffect(() => {
    localStorage.removeItem('persist:primary')
    dispatch({ type: 'clear_form_online', payload: {} })
  }, [dispatch])

  return (
    <>
      {state.loading ? (
        <Loader />
      ) : (
        <div>
          <div className="col-12 mx-auto text-center mt-4">
            <h2 style={{ fontWeight: 700 }} className="mx-3">
              Nueva Solicitud de Etapa de Tratamiento
            </h2>
            <h5>{stageTitleArray[state.step]}</h5>
          </div>
          {pageWidth === 'desktop' && (
            <StepBar
              state={state}
              stageTwoFinish={stageTwoFinish}
              stageThreeFinish={stageThreeFinish}
              stageFourFinish={stageFourFinish}
            />
          )}
          {state.step === 1 && (
            <StageStepOne state={state} setState={setState} />
          )}

          {state.step === 2 && (
            <TreatmentAdminStepTwo
              state={state}
              setState={setState}
              photosFiles={photosFiles}
              setPhotosFiles={setPhotosFiles}
            />
          )}

          {state.step === 3 && (
            <TreatmentAdminStepThree
              state={state}
              setState={setState}
              studiesFiles={studiesFiles}
              setStudiesFiles={setStudiesFiles}
            />
          )}

          {state.step === 4 && (
            <StageStepFour
              planFiles={planFiles}
              setPlanFiles={setPlanFiles}
              state={state}
              setState={setState}
              checkFrotalSonriendo={checkFrotalSonriendo}
            />
          )}

          {state.step === 5 && (
            <TreatmentStepFive state={state} setState={setState} />
          )}

          {state.step === 6 && (
            <StageStepSix
              photosFiles={photosFiles}
              studiesFiles={studiesFiles}
              planFiles={planFiles}
              state={state}
              setState={setState}
              stageTwoFinish={stageTwoFinish}
              stageThreeFinish={stageThreeFinish}
              stageFourFinish={stageFourFinish}
              checkFrotalSonriendo={checkFrotalSonriendo}
            />
          )}

          {state.step !== 6 && (
            <div
              className={
                pageWidth === 'desktop'
                  ? 'text-end pe-6 mt-4'
                  : 'text-center mt-4'
              }
            >
              {state.step > 1 && (
                <button
                  className="btn btn-light text-primary rounded-pill px-4 mx-2"
                  onClick={() => {
                    setState({
                      ...state,
                      step: state.step > 1 && state.step - 1,
                    })
                  }}
                >
                  <ChevronLeft size="16" /> Volver
                </button>
              )}
              <button
                disabled={state.online_plan && state.step === 4 ? true : false}
                className={`btn btn-primary rounded-pill px-4 ${
                  state.online_plan && state.step === 4
                    ? 'buttonFormOnline'
                    : ''
                }`}
                onClick={() => handleChangeStep()}
              >
                Continuar
              </button>
            </div>
          )}
          <div className="col-9 mx-auto mt-5">
            {stageFooterArray[state.step]}
          </div>
        </div>
      )}
    </>
  )
}

export default NewStage
